import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { Observable, map, catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AsyncEmailValidator implements AsyncValidator {
  constructor(private apiService: ApiService) {}

  validate(control: AbstractControl<string>): Observable<ValidationErrors | null> {
    return this.apiService.postEmailForValidation(control.value).pipe(
      map((response) => {
        if (response?.result) {
          return response.result.isValid ? null : { asyncValidatorMessage: response.result.userMessages };
        }

        return response?.message ? { asyncValidatorMessage: [response.message] } : null;
      }),
      catchError(() => of({ asyncEmailValidatorErrorMessage: true })),
    );
  }
}
